var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotateIcon = function SvgRotateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.527.094 3.485 1.97a.5.5 0 0 1 0 .871L6.527 4.906a.5.5 0 0 1-.746-.435V3.353c-1.586.238-2.465.85-2.968 1.476-.667.831-.797 1.84-.797 2.515a.75.75 0 0 1-1.5 0c0-.825.15-2.238 1.128-3.454.815-1.015 2.124-1.794 4.137-2.05V.53a.5.5 0 0 1 .746-.436ZM14 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H8Zm14 2H8v14h14v-2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2V9Z",
    fill: "#455A64"
  })));
};
export default SvgRotateIcon;